<ng-container *transloco="let t">
  <div
    class="d-flex justify-content-between align-items-stretch header-box__header pe-20">
    <div class="header-box__title d-flex align-items-center justify-content-center">
      {{title}}
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <div  class="text-uppercase text-white cursor-pointer" (click)="exportToPDF()">
        {{t('app.common.export.to.pdf')}}
      </div>
    </div>
  </div>
</ng-container>
